import { api } from "./api";

import type {
  AdminLoginInput,
  AdminUser
} from "../types/admin";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export async function loginAdmin(
  input: AdminLoginInput
): Promise<AdminUser> {
  const response =
    await api.post<ApiResponse<AdminUser>>(
      "/auth/login",
      input
    );

  return response.data.data;
}

export async function getCurrentAdmin():
Promise<AdminUser> {
  const response =
    await api.get<ApiResponse<AdminUser>>(
      "/auth/me"
    );

  return response.data.data;
}

export async function logoutAdmin():
Promise<void> {
  await api.post("/auth/logout");
}
